"use client";
import { SessionProvider } from "next-auth/react";
import type { Session } from "next-auth";

export default function SessionProviderWrapper(props: {
  children: React.ReactNode;
  session: Session | null;
}) {
  return (
    <SessionProvider session={props.session}>{props.children}</SessionProvider>
  );
}
